import React, { useEffect, useState } from "react";
import { Row, Col, Card, Select, Input, Space, Button } from "antd";
import { Typography } from "antd";
import "../style.css";
import { Link } from "react-router-dom";
import cad_flag from "../../Image/flag/cad_flag.png";
import barbados from "../../Image/flag/barbados.png";
import { generateClient } from "aws-amplify/api";
import { useTranslation } from "react-i18next";
const client = generateClient();
const { Title, Text } = Typography;
const { Option } = Select;

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const [currencyNow, setCurrencyNow] = useState("cad");
  const [currencyNow2, setCurrencyNow2] = useState("bbd");
  const [cadToBBDRate, setcadToBBDRate] = useState(0.1);
  const [bBDToCADSRate, setBBDToCadRate] = useState(0.1);
  const [sendRate, setSendRate] = useState(0.0);
  const [getRate, setGetRate] = useState(0.0);
  const [changeField1, setChangedField1] = useState(false);
  const [changeField2, setChangedField2] = useState(false);

  // currency list
  const currency_list = [
    {
      value: "cad",
      image: cad_flag,
      code: "CAD",
    },
    {
      value: "bbd",
      image: barbados,
      code: "BBD",
    },
  ];

  useEffect(() => {
    fetchCurrentRate();
  }, []);

  // fetch rate
  async function fetchCurrentRate() {
    const query = `query MyQuery {
      listAdmins {
        items {
          finalCADToBBD
          finalBBDToCAD

        }
      }
    }
    `;
    const response = await client.graphql({
      query: query,
    });

    setcadToBBDRate(response.data.listAdmins.items[0].finalCADToBBD);
    setBBDToCadRate(response.data.listAdmins.items[0].finalBBDToCAD);
    setGetRate(sendRate * cadToBBDRate);
  }

  const handleChange1 = (value) => {
    console.log(`selected ${value}`);
    setCurrencyNow(value);
    setCurrencyNow2(currency_list.find((item) => item.value !== value).value);
  };
  const handleChange2 = (value) => {
    console.log(`selected ${value}`);
    setCurrencyNow2(value);
    setCurrencyNow(currency_list.find((item) => item.value !== value).value);
  };

  return (
    <div style={{ padding: 20, backgroundColor: "#e6edff" }}>
      <Row>
        <Col className="homePartFirstLeft" xs={{ span: 24 }} lg={{ span: 12 }}>
          <Title level={2}>
            Fast, Secure, and Affordable Money Transfers between Canada and Barbados
          </Title>
          {/* <Text>Welcome to BajCan, the most reliable and cost-effective way to send money to BajCan. We understand how important it is to ensure your hard-earned money reaches its destination safely and quickly. That's why we offer a service that is</Text> */}
          <div style={{ marginTop: "3rem" }}>
            <Link to="signup">
              <Button shape="round" size="large" className="signup-btn">
                Sign up
              </Button>
            </Link>
          </div>
        </Col>
        <Col className="homePartFirstRight" xs={{ span: 24 }} lg={{ span: 12 }}>
          <Card className="converter-card">
            <div className="converter-title-container">
              <Text className="converter-title">Exchange Rate</Text>
              <Text className="converter-rate">
                {currencyNow === "cad"
                  ? `1 CAD = ${cadToBBDRate.toFixed(4)} BBD`
                  : `1 BBD = ${bBDToCADSRate.toFixed(4)} CAD `}
              </Text>
            </div>
            <div>
              <div className="converter-input-container">
                <Text strong className="converter-input-title">
                  You send exactly
                </Text>
                <Space.Compact>
                  <Input
                    placeholder="0"
                    value={
                      currencyNow === "cad"
                        ? changeField2
                          ? new Intl.NumberFormat().format(
                              getRate / cadToBBDRate
                            )
                          : new Intl.NumberFormat().format(sendRate)
                        : changeField2
                        ? new Intl.NumberFormat().format(
                            getRate / bBDToCADSRate
                          )
                        : new Intl.NumberFormat().format(sendRate)
                    }
                    style={{ borderRadius: "1rem 0rem 0rem 1rem" }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/,/g, ""); // Remove commas for calculation
                      if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                        setSendRate(value); // Keep this as a string to preserve input format (e.g., "1,000")
                        setChangedField1(true);
                        setChangedField2(false);
                        if (currencyNow === currencyNow2) {
                          setGetRate(value); // You might need to convert this back for calculations elsewhere
                        }
                      }
                    }}
                  />
                  <Select
                    className="select-border"
                    defaultValue="cad"
                    onChange={handleChange1}
                    value={currencyNow}
                  >
                    {currency_list.map((item) => (
                      <Option value={item.value} key={item.value}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.2rem",
                          }}
                        >
                          <img
                            src={item.image}
                            width={30}
                            height={30}
                            alt={item.code}
                          />
                          <Text>{item.code}</Text>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Space.Compact>
              </div>
              <div className="converter-input-container">
                <Text strong className="converter-input-title">
                  Recipient gets
                </Text>
                <Space.Compact>
                  <Input
                    placeholder={0}
                    value={
                      currencyNow === "cad"
                        ? changeField1
                          ? new Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(sendRate * cadToBBDRate)
                          : new Intl.NumberFormat("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(getRate)
                        : changeField1
                        ? new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(sendRate * bBDToCADSRate)
                        : new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(getRate)
                    }
                    onChange={(e) => {
                      const regex = /^[0-9]*\.?[0-9]*$/;
                      if (regex.test(e.target.value)) {
                        setGetRate(e.target.value);
                        setChangedField1(false);
                        setChangedField2(true);
                        if (currencyNow === currencyNow2) {
                          setSendRate(getRate);
                        }
                      }
                    }}
                    style={{ borderRadius: "1rem 0rem 0rem 1rem" }}
                  />
                  <Select
                    className="select-border"
                    defaultValue="bejcan"
                    onChange={handleChange2}
                    value={currencyNow2}
                  >
                    {currency_list.map((item) => (
                      <Option value={item.value} key={item.value}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.2rem",
                          }}
                        >
                          <img
                            src={item.image}
                            width={30}
                            height={30}
                            alt={item.code}
                          />
                          <Text>{item.code}</Text>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Space.Compact>
              </div>
              <div className="converter-btn-container">
                <Link to="/signIn">
                  <Button size="large" shape="round" className="converter-btn">
                    Send Now
                  </Button>
                </Link>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
export default HomePage;
